<template>
  <div class="exper-header">
    <div class="exper-header-back" @click="$router.go(-1)">
      <img :src="serverURL + 'images/back@2x.png'" alt="" />
      {{ $t('lang.index.exper_header.backButton') }}
    </div>
    <div class="exper-header-title">
      <img class="img-0" :src="serverURL + 'images/theme/purple-red/exp_header_left.png'" alt="" />
      <!-- <img class="img-1" :src="img" alt="" /> -->
      <div
        class="title"
        :class="
          getLocal() === 'zh'
            ? 'ZCOOL'
            : getLocal() === 'en'
            ? 'ZCOOL'
            : getLocal() === 'zh-hk'
            ? 'Noto'
            : ''
        "
      >
        {{ $t('lang.title.' + title) }}
      </div>
      <img class="img-2" :src="serverURL + 'images/theme/purple-red/exp_header_right.png'" alt="" />
    </div>
    <div class="exper-header-right">
      <div class="score">
        <p>{{ $t('lang.mz.score') }}</p>
        <span> {{ score }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { recordInfo } from '@/api/experimentation/test'
import { mapState } from 'vuex'
export default {
  components: {},
  props: ['img', 'title'],
  data() {
    return {
      isSelect: false,
    }
  },
  computed: {
    ...mapState(['score']),
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {
    this.getRecord()
  },
  getLocal() {
    return localStorage.getItem('translate')
  },
  mounted() {},
  methods: {
    getRecord() {
      let token = window.localStorage.getItem('token')
      if (!token) return
      let expId = window.localStorage.getItem('expId') || 1
      recordInfo(expId).then((res) => {
        const { score } = res.data
        this.$store.commit('SET_SCORE', score)
      })
    },
    getLocal() {
      return localStorage.getItem('translate')
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  // width: 410px;
  max-width: 50vw;
  padding: 0 40px;
  color: var(--red-color);
  font-size: 40px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  text-shadow: 2px 1px var(--exp-color);
}
.exper-header {
  width: 100%;
  padding: 3.4vh 2vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  &-title {
    display: flex;
    align-items: center;
    img {
      height: 35px;
      &:nth-child(2) {
        margin: 0 4vw;
      }
    }
  }
  &-back {
    width: 20%;
    font-size: 22px;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 30px;
      height: 30px;
      margin-right: 15px;
    }
  }
  &-right {
    width: 20%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .score {
      background-image: var(--exp_header_score);
      background-size: 100% 100%;
      padding: 1vh 2vw;
      display: flex;
      align-items: center;
      p {
        color: #666666;
        margin: 0;
        width: 2.5vw;
      }
      span {
        color: #a63528;
        font-size: 1.5vw;
        min-width: 3.5vw;
        text-align: center;
      }
    }
  }
}
</style>